<div class="custom-html-form">
  <ng-container >
    <div class="info">
      @if (!isLegacy) {
        <span>Please use the 'Edit Text' option in this page's edit mode to update the HTML template</span>
      }
      @if (isLegacy) {
        <span>Please use the 'Template Editor' tab to update the HTML template</span>
      }
      @if (!tileId && !isLegacy) {
        <span>, or click 'Build Report' to build a new context report</span>
        }.
      </div>
    </ng-container>

    @if (isLegacy) {
      <mat-tab-group [disableRipple]="true" class="custom-html-form-tab-group">
        <mat-tab [label]="'Select series'">
          <series-html-form [(config)]="config" (configChange)="relayConfigChange($event)"
          [(htmlString)]="config.paragraph_body"></series-html-form>
        </mat-tab>
        <mat-tab [label]="'Select components'">
          <component-report-builder [(config)]="config" (configChange)="relayConfigChange($event)"></component-report-builder>
        </mat-tab>
        <mat-tab [label]="'Select functions'">
          <function-builder [config]="config"></function-builder>
        </mat-tab>
      </mat-tab-group>
    }

  </div>
